export default __webpack_public_path__ + "images/6b28e971a477221ffd71714ac33dd300.jpeg";